// Configuration for MSAL authentication
// process.env.REACT_APP_* variables are replaced at BUILD TIME by webpack/react-scripts
// These values come from the .env file created during the GitLab CI build process
// A config.js file is also created in public/ as a backup/verification
// The config.js file sets window.__APP_CONFIG__ which is loaded via a script tag in index.html

// Helper to get config value with fallback
const getConfig = (key, defaultValue) => {
  if (typeof window !== 'undefined' && window.__APP_CONFIG__ && window.__APP_CONFIG__[key]) {
    return window.__APP_CONFIG__[key];
  }

  if (process.env[key]) {
    console.warn(`Using process.env, window.__APP_CONFIG__ not set for ${key} at runtime`);
    return process.env[key];
  }

  return defaultValue;
};

export const msalConfig = {
  auth: {
    clientId: getConfig('REACT_APP_CLIENT_ID', '36df0d64-b5a0-4970-975f-69bbfa7e34b7'),
    authority: "https://login.microsoftonline.com/common", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: getConfig('REACT_APP_MSAL_REDIRECT_URI', 'http://localhost:3000/auth'),
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: true, // Set to true to avoid cross-protocol iframe issues in development
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
